import { defineStore } from "pinia";
import apiClient from "@/plugins/axios";

export const useDirectoryStore = defineStore("directory", {
  state: () => ({
    companies: [],
    totalPages: 1,
    currentPage: 1,
    totalResults: 0,
    loading: false,
    error: "",
    searchCompany: "",
    searchNandina: "",
  }),

  actions: {
    /**
     * Obtener listado de empresas visibles en el directorio
     */
    async fetchDirectory(params = {}) {
      this.loading = true;
      this.error = "";

      try {
        const response = await apiClient.get("/directory", {
          params: {
            page: params.page ?? this.currentPage,
            q: params.q ?? this.searchCompany,
            nandina: params.nandina ?? this.searchNandina,
          },
        });

        this.companies = response.data.data;
        this.currentPage = Number(response.data.current_page);
        this.totalPages = Number(response.data.last_page);
        this.totalResults = Number(response.data.total);
      } catch (error) {
        if (error.code === "ERR_NETWORK") {
          this.error =
            "No se pudo conectar al servidor. Por favor, intenta nuevamente más tarde.";
        } else {
          this.error =
            error.response?.data?.message ||
            "Error al cargar el directorio. Intente de nuevo más tarde.";
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * Buscar por nombre de empresa
     */
    async searchByCompany(name) {
      this.searchCompany = name;
      this.currentPage = 1;
      await this.fetchDirectory();
    },

    /**
     * Buscar por código o descripción NANDINA
     */
    async searchByNandina(nandinaCode) {
      this.searchNandina = nandinaCode;
      this.currentPage = 1;
      await this.fetchDirectory();
    },

    /**
     * Cambiar de página
     */
    async changePage(page) {
      this.currentPage = page;
      await this.fetchDirectory();
    },

    /**
     * Resetear filtros
     */
    resetFilters() {
      this.searchCompany = "";
      this.searchNandina = "";
      this.currentPage = 1;
      this.error = "";
    },
  },
});
